// The part of the photo kept when the tile crops it.
export enum FocalPointEnum {
  CENTER = 'center',
  TOP = 'top',
  BOTTOM = 'bottom',
  LEFT = 'left',
  RIGHT = 'right',
}

export type EditorialTileTextStyles = {
  textColor?: string | undefined;
  backgroundColor?: string | undefined;
  fontWeight?: string | undefined;
};

export type EditorialTile = {
  id: string;
  href: string;
  image: { src: string; alt: string; focalPoint: FocalPointEnum };
  heading?: string | undefined;
  headingStyles?: EditorialTileTextStyles | undefined;
  label?: string | undefined;
  labelStyles?: EditorialTileTextStyles | undefined;
  tracking: { bannerName: string; ctaLabel: string };
};
